export default __webpack_public_path__ + "static/media/n8n.55dcf941.png";